var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { parseMove } from './typeConversions';
import { get, isNil } from 'lodash';
import { lazyObservable } from 'mobx-utils';
var backendBaseUrl = function () { return (process.env.REACT_APP_BACKEND_HOST ? "//" + process.env.REACT_APP_BACKEND_HOST : ''); };
var apiBaseUrl = function () { return backendBaseUrl() + "/api/v1"; };
var getApiHeaders = function (password) {
    if (password === void 0) { password = ''; }
    return ({
        Authorization: "Bearer " + password,
    });
};
var API = {
    accessToken: '',
    setAccessToken: function (token) {
        this.accessToken = token;
    },
    getMove: function (moveId) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/moves/" + moveId;
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.get(URL, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, parseMove(response.data)];
                        }
                        throw new Error('Error getting move');
                }
            });
        });
    },
    saveMove: function (moveId, move) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/moves/" + moveId;
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.patch(URL, __assign(__assign({}, move), { stickersCount: move.stickersCount }), config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error saving move options');
                }
            });
        });
    },
    getUnassignedOwners: function (moveId) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/moves/" + moveId + "/unassigned-people";
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.get(URL, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data.unassignedPeople];
                        }
                        throw new Error('Error getting unassigned owners');
                }
            });
        });
    },
    saveUnassignedOwners: function (moveId, owners) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, data, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/moves/" + moveId;
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        data = {
                            unassignedPeople: owners.map(function (o) { return o.name; }),
                        };
                        return [4 /*yield*/, axios.patch(URL, data, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error saving unassigned owners');
                }
            });
        });
    },
    getAllLayouts: function (moveId) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/moves/" + moveId + "/layouts";
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.get(URL, config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, get(response, 'data', []).map(function (x) {
                                return {
                                    id: x.id,
                                    floor_name: x.floor_name,
                                    url: apiBaseUrl() + "/layouts/" + x.id + "/image",
                                };
                            })];
                }
            });
        });
    },
    getLayoutData: function (moveId, id) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, response, responseData, floorLayout;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/layouts/" + id;
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.get(URL, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            responseData = get(response, 'data', []);
                            floorLayout = {
                                id: responseData.id,
                                floor_name: responseData.floor_name,
                                url: apiBaseUrl() + "/layouts/" + responseData.id + "/image",
                                markers: responseData.markers,
                                filename: responseData.file_name,
                                labelColor: responseData.label_color,
                                floorSize: responseData.floor_size,
                                isDefault: responseData.isDefault,
                            };
                            return [2 /*return*/, floorLayout];
                        }
                        throw new Error('Error getting all layouts');
                }
            });
        });
    },
    postNewLayout: function (moveId, floorName, file, labelColor, floorSize, isDefault) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, data, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/moves/" + moveId + "/layouts";
                        data = new FormData();
                        // This format is what rails backend assumes
                        data.append('floor_name', floorName);
                        data.append('layout', file);
                        if (labelColor) {
                            data.append('label_color', labelColor);
                        }
                        data.append('floor_size', floorSize);
                        data.append('published', 'true');
                        data.append('isDefault', isDefault.toString());
                        config = {
                            headers: __assign({ 'content-type': 'multipart/form-data' }, getApiHeaders(this.accessToken)),
                        };
                        return [4 /*yield*/, axios.post(URL, data, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 201) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error saving new layout');
                }
            });
        });
    },
    deleteLayout: function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/layouts/" + id;
                        config = {
                            headers: __assign({}, getApiHeaders(this.accessToken)),
                        };
                        return [4 /*yield*/, axios.delete(URL, config)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    postNewMarker: function (marker) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/layouts/" + marker.move_layout_id + "/markers";
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.post(URL, marker, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 201) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error creating new marker');
                }
            });
        });
    },
    removeMarker: function (tagId) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/markers/" + tagId;
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.delete(URL, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error removing marker');
                }
            });
        });
    },
    updateMarker: function (marker) {
        return __awaiter(this, void 0, void 0, function () {
            var URL_1, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!isNil(marker.id)) return [3 /*break*/, 2];
                        URL_1 = apiBaseUrl() + "/markers/" + marker.id;
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.put(URL_1, marker, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error updating marker');
                    case 2: return [2 /*return*/];
                }
            });
        });
    },
    // Marker id is the marker where owner is saved (SpaceTag or TableTag)
    // Owner name is used to create a new user to marker in database.
    // It creates an id for that user and returns it in response
    saveNewOwner: function (markerId, ownerName) {
        return __awaiter(this, void 0, void 0, function () {
            var URL, user, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = apiBaseUrl() + "/marker-users";
                        user = {
                            name: ownerName,
                            move_layout_marker_id: markerId,
                        };
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.post(URL, user, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 201) {
                            return [2 /*return*/, response];
                        }
                        if (response.status === 422) {
                            throw new Error('Invalid request');
                        }
                        throw new Error('Error creating new marker user');
                }
            });
        });
    },
    deleteMarkerOwner: function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var URL_2, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!isNil(id)) return [3 /*break*/, 2];
                        URL_2 = apiBaseUrl() + "/marker-users/" + id;
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.delete(URL_2, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error deleting marker user');
                    case 2: return [2 /*return*/];
                }
            });
        });
    },
    updateMarkerOwner: function (owner) {
        return __awaiter(this, void 0, void 0, function () {
            var URL_3, spaceId, user, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!isNil(owner.id)) return [3 /*break*/, 2];
                        URL_3 = apiBaseUrl() + "/marker-users/" + owner.id;
                        spaceId = void 0;
                        if (owner.table && owner.table.id) {
                            spaceId = owner.table.id;
                        }
                        else if (owner.space && owner.space.id) {
                            spaceId = owner.space.id;
                        }
                        user = {
                            name: owner.name,
                            move_layout_marker_id: spaceId,
                            stickersCount: owner.stickersNumber,
                        };
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.put(URL_3, user, config)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response];
                        }
                        throw new Error('Error updating marker user');
                    case 2: return [2 /*return*/];
                }
            });
        });
    },
    fetchCSVExports: function (moveId) {
        return __awaiter(this, void 0, void 0, function () {
            var config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.get(apiURL("/moves/" + moveId + "/layouts.csv"), config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    },
    updateFloor: function (floorId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            headers: getApiHeaders(this.accessToken),
                        };
                        return [4 /*yield*/, axios.patch(apiURL("/layouts/" + floorId), payload, config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    },
};
/*
  Helpers
*/
export var backendURL = function (path) { return backendBaseUrl() + path; };
export var apiURL = function (path) { return apiBaseUrl() + path; };
export var apiHeaders = function (customHeaders) {
    if (customHeaders === void 0) { customHeaders = {}; }
    return __assign(__assign({}, customHeaders), getApiHeaders());
};
export var apiAxiosConfig = function (customHeaders) {
    if (customHeaders === void 0) { customHeaders = {}; }
    return {
        headers: apiHeaders(customHeaders),
    };
};
// Adapted from https://gist.github.com/remojansen/16c661a7afd68e22ac6e
// and https://stackoverflow.com/a/45021102
export var handleAsyncErrors = function (options) {
    return function (target, propertyKey, descriptor) {
        var originalMethod = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, originalMethod.apply(this, args)];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            error_1 = _a.sent();
                            // @todo: Implement correct error handling
                            if (options.logErrorMessage) {
                                console.error(options.logErrorMessage);
                            }
                            else if (options.alertErrorMessage) {
                                window.alert(options.alertErrorMessage);
                            }
                            console.error(error_1.message);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        return descriptor;
    };
};
export function expect(expectedHttpStatus, response) {
    if (response.status !== expectedHttpStatus) {
        throw new Error("Expected HTTP " + expectedHttpStatus + ", but got HTTP " + response.status + " instead");
    }
    return response;
}
export function simpleLazyObservable(context, fetcher, initialValue) {
    return lazyObservable(function (sink) {
        fetcher
            .bind(context)()
            .then(function (val) {
            sink(val);
        });
    }, initialValue);
}
export default API;
//# sourceMappingURL=api.js.map